import { sortArray } from '@nu-art/ts-common';
export const SearchSorter_SearchTerm = {
    key: 'searchTerm',
    sortFunction: (results) => {
        sortArray(results, result => result.filterResults[SearchSorter_SearchTerm.key].value.length);
        sortArray(results, result => result.filterResults[SearchSorter_SearchTerm.key].score);
    }
};
//# sourceMappingURL=SearchSorter_SearchTerm.js.map